<template>
  <draggable
    :list="receiptLines"
    ghost-class="ghost"
    @change="linesChanged()"
  >
    <div
      v-for="(line, idx) in receiptLines"
      :key="idx"
      class="list-group-item"
    >
      <v-row align="center">
        <v-col cols="auto">
          <v-avatar
            color="grey"
            size="25"
            tile
            outline
          >
            <span class="white--text">{{ idx + 1 }}</span>
          </v-avatar>
        </v-col>
        <v-divider vertical />
        <v-col>
          <v-row>
            <v-col
              v-for="(comp, i) in line.components"
              :key="i"
              class="line-config-item"
            >
              <template-line
                :data="comp"
                @edit="styleConfig"
                @editSettings="editSettings"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-divider vertical />
        <v-col
          cols="auto"
        >
          <v-btn
            icon
            color="success"
            small
            @click="editLine(line)"
          >
            <v-icon small>
              mdi-circle-edit-outline
            </v-icon>
          </v-btn>
          <v-btn
            icon
            color="danger"
            small
            @click="removeLine(line)"
          >
            <v-icon small>
              mdi-delete
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </draggable>
</template>

<script>
import Draggable from "vuedraggable";
import TemplateLine from "./TemplateLine.vue";
export default {
  name: "TemplateLines",
  components: {
    Draggable,
    TemplateLine
  },
  props: {
    lines: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      receiptLines: []
    };
  },
  computed: {},
  watch: {
    lines() {
      this.formLines();
    }
  },
  created() {
    this.formLines();
  },
  methods: {
    formLines() {
      if (!this.lines) return [];
      let final = [];
      let initial = JSON.parse(JSON.stringify(this.lines));
      initial.forEach(line => {
        final.push(line);
      });
      this.receiptLines = final;
    },
    linesChanged() {
      this.$emit("lineChange", this.receiptLines);
    },
    styleConfig(comp) {
      this.$emit("editStyle", comp.style, comp.refId);
    },
    editSettings(comp) {
      this.$emit("editSettings", comp);
    },
    editLine(line) {
      this.$emit("editLine", line);
    },
    removeLine(line) {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to remove the line ?", {})
        .then((confirm) => {
          if (confirm) {
            this.$emit("removeLine", line);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.list-group-item {
  position: inherit;
  display: block;
  padding: 10px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  cursor: move;
  &:not(:last-child) {
    border-bottom: 0;
  }
}

.line-config-item {
  &:not(:last-child) {
    border-right: 1px dashed rgba(0, 0, 0, 0.125);
  }
}

</style>